import CircularProgress from "@mui/material/CircularProgress"


const Spinner = ({styles, classes, xs, small = false, medium = false, large = false, ...rest}) => {
  const sizing = {
    ...(xs && {
      height: '12px',
      width: '12px'
    }),
    ...(small && {
      height: '25px',
      width: '25px'
    }),
    ...(medium && {
      height: '40px',
      width: '40px'
    }),
    ...(large && {
      height: '60px',
      width: '60px'
    })
  }

  return (
    <CircularProgress style={{...sizing, ...styles}} className={classes} color="primary" {...rest} />
  )
}

export default Spinner